<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$refs.formModal.create()">
          <i class="plus icon"></i> Novo Tipo
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="exam-types-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="exam-types-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" @onRowClick="onUpdate" />

    <form-modal ref="formModal" @onSave="refresh" @onRemove="refresh" />

  </div>

</template>

<script>
  
  import ExamTypeService from "@/services/exam-type-service"
  import FormModal from "./form-modal"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "ExamTypesPage",

    mixins: [gridPage, onlySimavet],

    data() {
      return {        
        title: "Tipos de Exames",
        service: new ExamTypeService(),
        attributes: ["id", "description"],
        fields: [          
          { prop: "description", label: "Descrição" },           
        ],
      }
    },

    components: {
      FormModal,
    },

    methods: {

      onUpdate(data) {
        this.$refs.formModal.update(data.row)
      }
    },
  }

</script>
